import { textWithHTML, percentage } from 'Data/format.js'

export function getText(ach_fee_percent) {
  return textWithHTML(
    `A <b>platform fee of ${percentage(
      ach_fee_percent
    )}</b> will be applied to ACH payments. By continuing, you acknowledge that the responsible party has authorized this fee.`
  )
}
